var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5100",
    stroke: "#FF5100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.44,
    d: "M12.72 14.32h-8c-2.4 0-4-1.2-4-4v-5.6c0-2.8 1.6-4 4-4h8c2.4 0 4 1.2 4 4v5.6c0 2.8-1.6 4-4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.852,
    d: "M12.06 5.328 9.972 6.995c-.687.547-1.814.547-2.5 0l-2.08-1.667"
  })));
};
export default SvgInbox;